import axiosPost from "./axiosPost";

export const TipoDeSociedadGet = async (credentials) => {
    const body = {
        service: "TipoDeSociedadGet",
        params: {},
    };
    try {
        const response = await axiosPost("Y", body, credentials);
        return response;
    } catch (err) {
        console.error(`Error: ${err}`);
    }
};
